import { validateWorkflow } from '../utils/workflow-transcript'
import { getStoryProgress } from '../utils/workflow-map-state'
import { getRoleStyles } from '../utils/workflow-colors'
import { getEmphasisTerms } from '../utils/workflow-copy'

export default {
  data() {
    return { activeStep: Number(this.workflow.steps?.[0]?.number || 1), progress: 1, scrollFrame: null }
  },
  computed: {
    checkedWorkflow() {
      return validateWorkflow(this.workflow)
    },
    roleStyles() {
      return getRoleStyles(this.checkedWorkflow)
    },
    storyEmphasis() {
      return this.checkedWorkflow.steps.map((step, index) => getEmphasisTerms(this.checkedWorkflow, index))
    }
  },
  watch: {
    workflow() {
      this.activeStep = Number(this.workflow.steps?.[0]?.number || 1)
      this.progress = 1
      this.$nextTick(() => {
        this.$refs.story.scrollTop = 0
        this.updateFromScroll()
      })
    }
  },
  mounted() {
    this.$nextTick(this.updateFromScroll)
    window.addEventListener('resize', this.requestScrollUpdate)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.requestScrollUpdate)
    if (this.scrollFrame !== null) cancelAnimationFrame(this.scrollFrame)
  },
  methods: {
    sections() {
      return Array.from(this.$refs.story.querySelectorAll('.wv-step'))
    },
    updateFromScroll() {
      if (!this.$refs.story?.clientHeight) return
      const progress = getStoryProgress(this.$refs.story, this.sections())
      this.progress = progress
      const index = Math.max(0, Math.min(this.checkedWorkflow.steps.length - 1, Math.round(progress) - 1))
      this.activeStep = Number(this.checkedWorkflow.steps[index].number)
    },
    requestScrollUpdate() {
      if (this.scrollFrame !== null) return
      this.scrollFrame = requestAnimationFrame(() => {
        this.scrollFrame = null
        this.updateFromScroll()
      })
    },
    scrollStory(event) {
      if (event.ctrlKey) return
      const story = this.$refs.story
      const unit = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? story.clientHeight : 1
      story.scrollTop += event.deltaY * unit
      this.requestScrollUpdate()
    },
    selectStep(number) {
      const section = this.sections().find(item => Number(item.dataset.step) === number)
      const story = this.$refs.story
      if (!section) return
      const top = section.offsetTop - story.clientHeight / 2 + section.offsetHeight / 2
      story.scrollTo({
        top,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      })
    }
  }
}
